<template>
<div>
    <div id="loaderoverlay" v-bind:style={display:onloader}>
        <div class="w-100 d-flex justify-content-center align-items-center">
            <div class="loaderspinner"></div>
        </div>
    </div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
        <router-link to="/dashboard" class="text-white pl-3">
            <i class="ni ni-tv-2"></i> Dashborad
        </router-link><i class="ni ni-bold-right text-white"></i>     
        <span class="text-white"><i class="ni ni-bold-right"></i>Department</span>
    </base-header>

    <!--Charts-->
    <div class="container-fluid mt--7">
        <card header-classes="bg-transparent">
            <div class="row">
                <div class="col-md-6">
                     <div class="card bg-secondary border-0 mb-0">
                        <div class="card-body">
                            <div class="form-horizontal">
                                <form role="form" @submit.prevent="submitdata">
                                    <div class="form-group">                                       
                                        <input v-model="DepartmentNameval" class="form-control" placeholder="Enter Department Name" required>
                                    </div>                                                             
                                    <hr>
                                    <div class="text-center mb-3">                                   
                                        <button type="submit" class="btn btn-primary my-4">Submit</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                 <div class="col-md-6">
                    <div class="form-inline">                   
                    <div class=" input-group">
                        <input v-model="searchval" class="form-control" @keyup="getsearch" placeholder="Search...">
                        <div class=" input-group-append">
                            <button type="button" @click.prevent="getsearch" class="btn btn-secondary"><i class="fa fa-search"></i> Search </button>
                        </div>
                    </div>
                </div>
                <div class="table-responsive">
                    <table class="table table-border">
                        <thead>
                            <tr>                                
                                <th>Department Name</th>                               
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in resultitems" :key="item.Id">
                                <td>{{item.DepartmentName}}</td>
                                 <td> <button class="btn btn-secondary btn-sm my-2" v-on:click="edititem(item.Id)"><i class="fa fa-edit"></i> Edit</button>  </td>
                            </tr>
                        </tbody>
                    </table>                   
                </div>
                </div>               
            </div>          
        </card>
    </div>
</div>
</template>

<script>
import moment from 'moment'
import swal from 'sweetalert'
export default {   
    name: 'Department',
    data() {
        return {
            Idval: 1,           
            DepartmentNameval: '',          
            searchval: '',
            resultitems:null,
            process: 'N',                  
            onloader: 'none'
        }
    },   
    methods: {        
        edititem: function (Id) {
            this.onloader = 'flex'
            this.$store.dispatch('getDepartmentbyid', Id)
                .then(resp => {                   
                    this.Idval = resp.Id;                    
                    this.DepartmentNameval= resp.DepartmentName;                   
                    this.process = 'U';
                    this.onloader = 'none';
                })
                .catch(err => {
                    this.onloader = 'none'
                    this.checkresponse(err.response.data);
                })
        },     
        submitdata: function () {
            let Id = this.Idval;
            let DepartmentName = this.DepartmentNameval;            
            let Operation = this.process;
            let Username = this.$store.state.auth.token;         
            this.onloader = 'flex';
            let userdata={Id, DepartmentName, Operation, Username}           
            this.$store.dispatch('processdepartment', userdata)
                .then((resp) => {
                    this.resultitems = resp;
                    this.DepartmentNameval='';
                    this.process ='N';
                    this.onloader = 'none'
                    swal({
                        title: "Success!",
                        text: 'Submitted successfully',
                        icon: "success",
                        button: "Ok",
                    });
                })
                .catch(err => {
                    this.onloader = 'none'
                    this.checkresponse(err.response.data);
                })
        },
        getdepartment: function () {
            this.onloader = 'flex'
            this.$store.dispatch('getdepartment')
                .then((resp) => {
                    this.resultitems = resp;
                    this.onloader = 'none'
                })
                .catch(err => {
                    this.onloader = 'none'
                    this.checkresponse(err.response.data);
                })
        },
        getsearch: function () {
            this.$store.dispatch('getdepartmentbysearch', this.searchval)
                .then((resp) => {
                    this.resultitems = resp;
                    //console.log(resp)
                })
                .catch(err => {
                    this.checkresponse(err.response.data);
                })
        },  
        frontEndDateFormat: function (date) {
            return moment(date).format('YYYY-MM-DD');
        },
        backEndDateFormat: function (date) {
            return moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
        },
        checkresponse: function (resp) {
            if (resp === "Access Expired" || resp === "Invalid Credential") {
                this.$store.dispatch('logout');
                this.$router.push('/login')
            } else {
                console.log(resp);
            }
        }

    },
    mounted() {
        if (this.$store.state.auth.user_status_id != 2) {
            this.$store.dispatch('logout')
            this.$router.push('/login')
        } else { 
               
            this.getdepartment();            
        }

    }
};
</script>

<style>

</style>
